import { supabase } from '../lib/supabase';
import type { VersiculoDelDia } from '../types';

/**
 * Fetches the verse of the day (date-seeded, cached in DB).
 * Uses Supabase RPC get_versiculo_del_dia(); safe to call unauthenticated (e.g. login page).
 */
export async function getVersiculoDelDia(): Promise<VersiculoDelDia | null> {
  const { data, error } = await supabase.rpc('get_versiculo_del_dia');
  if (error) {
    console.warn('VersiculoDelDia: RPC error', error);
    return null;
  }
  const row = Array.isArray(data) && data.length > 0 ? data[0] : data;
  if (!row || typeof row !== 'object') return null;
  return {
    id: row.id,
    categoria_id: row.categoria_id,
    ref_es: row.ref_es,
    ref_en: row.ref_en,
    texto_es: row.texto_es,
    texto_en: row.texto_en,
  };
}
